import styled from "styled-components";

export const Wrapper = styled.div`
  .text-container {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    background: linear-gradient(110deg, #0e1215ab 60%, #77caeb 60%);
    color: #fff;
    border-radius: 10px;
    padding: 10px;
  }
  .ant-tree {
    .ant-tree-treenode {
      width: 100%;
      margin-bottom: 10px;
    }
    .ant-tree-node-content-wrapper {
      width: 100%;
    }
  }

  .maintitle {
    background-color: #001529;
    color: #fff;
    border-radius: 10px;
    padding: 10px;
    font-size: 22px;

    p {
      margin: 0px;
    }
  }
  .ant-layout:hover {
    background: transparent;
    border: 2px solid #001529;
    color: black;
  }
  .sub-title {
    font-size: 17px;
    color: #fff;
    border-radius: 10px;
    padding: 10px;
    background-color: #0f171de3;
    p {
      margin: 0px;
    }
  }
  .inner-container {
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .input-container {
    width: 35%;
  }
  .input-inner-container {
    width: 34%;
  }
  .ant-btn {
    border-radius: 10px;
    width: 30%;
    margin-right: 5px;
  }
  .ant-tree-list{
    background: #e1eff6;
}
`;
